import React from "react";
import { TextField, InputLabel } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useField, useFormikContext } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import { getTheme } from "./getLocalTheme";

const useStyles = makeStyles({
  error: {
    color: "red",
    fontSize: "0.75rem",
    marginTop: 4,
  },
});

type Props<Type> = {
  fieldId: string;
  fieldName: string;
  fieldDisplayName: string;
  fullWidth?: boolean;
  options: Type[] | undefined;
  getOptionLabel: (option: Type) => string;
  getOptionValue: (option: Type) => any; 
  required?: boolean;
  variant?: "outlined" | "filled" | "standard";
};

function LSDBFormikAutocompleteField<Type>({
  fieldId,
  fieldName,
  fieldDisplayName,
  fullWidth,
  options,
  getOptionLabel,
  getOptionValue,
  required,
  variant = "standard",
}: Props<Type>) {
  const classes = useStyles();
  const { setFieldValue } = useFormikContext<any>();
  const [field, meta] = useField(fieldName);

  const hasError = meta.touched && Boolean(meta.error);

  
  const selectedOption =
    options?.find(
      (opt) => getOptionValue(opt) === field.value
    ) || null;

  return (
    <div style={{ paddingBottom: 32 }}>
      <InputLabel htmlFor={fieldId} required={required}>{fieldDisplayName}</InputLabel>

      <Autocomplete
        options={options || []}
        getOptionLabel={getOptionLabel}
        value={selectedOption}
        disabled={getTheme()}
        onChange={( e,newValue) => {
          setFieldValue(
            fieldName,
            newValue ? getOptionValue(newValue) : ""
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant={variant}
            margin="dense"
            fullWidth={fullWidth}
            // error={hasError}
            // helperText={hasError ? meta.error : ""}
            required={required}
          />
        )}
      />

      {hasError && <div className={classes.error}>{meta.error}</div>}
    </div>
  );
}

export default LSDBFormikAutocompleteField;